// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__CXhFy","wrapper":"style_wrapper__qC3lg"};